import { type Mat3dFigureModule } from "./mat3d-figure-types";

/**
 * Laedt den 3D-Chunk (three.js + Figur). Eigenes Modul, damit der Spec der
 * Insel einen gescheiterten Chunk-Load nachstellen kann. Rollup benennt den
 * Chunk nach dem Einstieg `mat3d-figure` — das Budget-Skript zaehlt ihn daran.
 */
export const loadFigureModule = (): Promise<Mat3dFigureModule> => import("./mat3d-figure");
